import React from 'react';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import styled from 'styled-components';

export type SelectedCommentSection = 'all' | 'commented';

interface SectionButtonsProps {
  numberOfComments: number | undefined;
  selectedSection: SelectedCommentSection;
  handleSectionChange: (section: SelectedCommentSection) => unknown;
  className?: string;
}

const StyledDiv = styled.div`
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.02em;
  display: flex;
  .left-button,
  .right-button {
    cursor: pointer;
    outline: none;
    border: none;
    background-color: ${COLORS.grayLight};
    padding: ${SPACERS.tiny} ${SPACERS.small};
  }
  .left-button {
    border-radius: 4px 0px 0px 4px;
  }
  .right-button {
    border-radius: 0px 4px 4px 0px;
  }
  .selected {
    color: ${COLORS.whiteBase};
    background-color: ${COLORS.ctaPrimary};
  }
`;

const SectionButtons: React.FC<SectionButtonsProps> = ({
  numberOfComments = 0,
  selectedSection,
  handleSectionChange,
  className,
}) => {
  return (
    <StyledDiv className={className}>
      <button
        onClick={() => handleSectionChange('all')}
        className={`left-button${selectedSection === 'all' ? ' selected' : ''}`}
      >
        All
      </button>
      <button
        onClick={() => handleSectionChange('commented')}
        className={`right-button${
          selectedSection === 'commented' ? ' selected' : ''
        }`}
      >
        Commented ({numberOfComments})
      </button>
    </StyledDiv>
  );
};

export default SectionButtons;
